/**
 * Toggles the "dark" class on a shadow host based on its data-theme attribute,
 * so :host(.dark) in @vicreturns/tailwind-preset/theme.css picks up the alternate
 * token values. Must run before attachShadow — :host() only matches classes on the
 * host element itself, not anything inside the shadow tree.
 */
export function applyTheme(host: HTMLElement) {
  if (host.dataset.theme === "dark") {
    host.classList.add("dark");
  }
}
